import { getUsersMeOrganisationsCurrentSavingsPlansSelector } from "./getUsersMeOrganisationsCurrentSavingsPlansSelector";
import { RootState } from "../../../../../store";
import { commitmentsGranularPayloadDataSelector } from "../payload/commitmentsGranularPayloadDataSelector";

export const commitmentsForGranularSelector = (state: RootState) => {
  const payload = commitmentsGranularPayloadDataSelector(state);

  return getUsersMeOrganisationsCurrentSavingsPlansSelector(payload)(state);
};
